type OeeRouteFlagKey =
    | 'enable_stations'
    | 'enable_analytics'
    | 'enable_process_flow'
    | 'enable_batch_history'
    | 'enable_product_families'
    | 'enable_operators'

export type OeeDefaultRouteFlags = Record<OeeRouteFlagKey, boolean>

const DEFAULT_FLAGS: OeeDefaultRouteFlags = {
    enable_stations: true,
    enable_analytics: true,
    enable_process_flow: true,
    enable_batch_history: true,
    enable_product_families: true,
    enable_operators: true,
}

const OEE_ROUTE_ORDER: Array<{ moduleId: string; flag: OeeRouteFlagKey; route: string }> = [
    { moduleId: 'oee_stations', flag: 'enable_stations', route: '/oee/stations' },
    { moduleId: 'oee_analytics', flag: 'enable_analytics', route: '/oee/analytics' },
    { moduleId: 'oee_process_flow', flag: 'enable_process_flow', route: '/oee/process-flow' },
    { moduleId: 'oee_batch_history', flag: 'enable_batch_history', route: '/oee/job-history' },
    { moduleId: 'oee_products', flag: 'enable_product_families', route: '/oee/products' },
    { moduleId: 'oee_operators', flag: 'enable_operators', route: '/oee/operators' },
]

/**
 * Pure helper: pick the OEE sub-route a user should land on when they hit `/oee`.
 *
 * Order of preference matches the visible OEE nav:
 * stations -> analytics -> process-flow -> job-history -> products -> operators.
 *
 * - null `visibleModules` means wildcard / no role override; still honor org page flags.
 * - User has at least one enabled sub-module -> that one in preference order.
 * - User has `oee` parent but no enabled sub-modules, or no oee at all -> null.
 *   The caller decides where to send them (e.g. /projects).
 */
export function pickDefaultOeeSubRoute(
    visibleModules: string[] | null,
    flags: Partial<OeeDefaultRouteFlags> = DEFAULT_FLAGS
): string | null {
    const mergedFlags: OeeDefaultRouteFlags = { ...DEFAULT_FLAGS, ...flags }

    for (const { moduleId, flag, route } of OEE_ROUTE_ORDER) {
        if (!mergedFlags[flag]) continue
        if (visibleModules === null || visibleModules.includes(moduleId)) return route
    }

    return null
}
